import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService, ResponsavelRdaService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class EntidadeSelecionadaGuard implements CanActivate {

  constructor(private readonly router: Router,
    private readonly securityService: SecurityService,
    private readonly responsavelRdaService: ResponsavelRdaService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return new Observable(subscriber => {
      if (this.securityService.isEntidadeSelecionada()) {
        if (this.securityService.isEmpresaAutenticada()) {
          this.responsavelRdaService.isResponsavelIndicado().subscribe(
            (indicouResponsavel) => {
              if (!indicouResponsavel) {
                this.router.navigate(['/responsavel-rda']).then(() => {
                  subscriber.next(false);
                  subscriber.complete();
                });
              }
            })
        }
        subscriber.next(true);
        subscriber.complete();
      } else {
        this.router.navigate(['/entidades/selecionar']).then(() => {
          subscriber.next(false);
          subscriber.complete();
        });
      }
    })
  }
}
